export default __webpack_public_path__ + "90478233303b7d6bd86664de3f320af9.svg";